/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Home_Card_BadgeInputs */

const en_dr_home_card_badge = /** @type {(inputs: Dr_Home_Card_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const id_dr_home_card_badge = /** @type {(inputs: Dr_Home_Card_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Dr_Home_Card_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_home_card_badge = /** @type {((inputs?: Dr_Home_Card_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Home_Card_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_home_card_badge(inputs)
	return en_dr_home_card_badge(inputs)
});